import {  ArrayObservable  } from './ArrayObservable';

export const of = ArrayObservable.of;


// WEBPACK FOOTER //
// ../../src/observable/of.ts